import React, { Component } from 'react'


export default class PlanBottom extends Component {

    render() {

        const PjtTxt = () => {

            return(

                <React.Fragment>
                    <span className='PlanBottomOne'>Engine</span>
                    <span className='PlanBottomTwo'>Future Proof Achitecture, Multiple Store, MSA Ready</span>
                    <span className='PlanBottomOne'>Store Front</span>
                    <span className='PlanBottomTwo'>SPA & PWA, i18n, RESTful, Decouple Template and Business Logic</span>
                    <span className='PlanBottomOne'>Admin Panel</span>
                    <span className='PlanBottomTwo'>Focus on a Operator, not Developer</span>
                </React.Fragment>

            )

        }

        const RancherTxt = () => {
 
            return(
                
                <React.Fragment>
                    <span className='PlanBottomOne'>ECMA Script</span>
                    <span className='PlanBottomTwo'>ECMA Script, node.js, and React. (Plus Electron, and React Native if possible.) </span>
                    <span className='PlanBottomOne'>Python</span>
                    <span className='PlanBottomTwo'>Flask for building webapp. Pandas for data.</span>
                    <span className='PlanBottomOne'>Mobile Apps</span>
                    <span className='PlanBottomTwo'>Launch more than one android apps on Google Store include candle calcurator.</span>
                </React.Fragment>

            )

        }


		return (

            <div id='PlanBottom'>
                <div id='PlanBottomBox'>
                    {this.props.isPjt ? <PjtTxt /> : <RancherTxt /> }
                </div>
            </div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/plan/PlanBottom.js